import * as React from 'react';
import { SelectorListSize } from '../Content';

export type ToggleAllCheckboxProps = {
  selectAllText?: string;
  deselectAllText?: string;
  enabledItemsAmount: number;
  selectedEnabledItemsAmount: number;
  selectAll: () => void;
  deselectAll: () => void;
  size?: SelectorListSize;
  dataHook?: string;
};

declare const ToggleAllCheckbox: React.FC<ToggleAllCheckboxProps>;
export default ToggleAllCheckbox;
